import React, { useState } from "react";
import "./ActivityDetail.css";
import devi1 from '../../img/devi.webp'; 
import devi2 from '../../img/devi2.webp'; 
import devi3 from '../../img/devi3.jpg'; 

import ayurved1 from '../../img/ayurved.webp'; 
import ayurved2 from '../../img/ayurved2.webp'; 
import ayurved3 from '../../img/ayurved3.avif'; 

import yoga1 from '../../img/yoga1.webp'; 
import yoga2 from '../../img/yoga2.webp'; 
import yoga3 from '../../img/yoga3.jpg'; 

import music1 from '../../img/music1.webp'; 
import music2 from '../../img/music2.avif'; 
import music3 from '../../img/music3.avif'; 

const ActivityDetail = () => {
  const [currentImages, setCurrentImages] = useState([0, 0, 0, 0]);

  const activities = [
    {
      title: "Anthropological and Iconographical Aspects of Devi Mahatmya",
      description: [
        "Explore the anthropological significance of Devi Mahatmya.",
        "Delve into the iconographical representations of Devi in various traditions.",
        "Understand the cultural impact and relevance of these aspects in modern times."
      ],
      images: [devi1, devi2, devi3],
    },
    {
      title: "आयुर्वेद - जगण्याचे सर्वात जुने शास्त्र",
      description: [
        "Learn about the origins and principles of Ayurveda.",
        "Discover its relevance in contemporary health practices.",
        "Explore the connection between Ayurveda and holistic living."
      ],
      images: [ayurved1, ayurved2, ayurved3],
    },
    {
      title: "World Yoga Day Special Workshop",
      description: [
        "Participate in a global celebration of yoga.",
        "Engage with expert yoga instructors for unique sessions.",
        "Learn about the spiritual and physical benefits of yoga."
      ],
      images: [yoga1, yoga2, yoga3],
    },
    {
      title: "Heritage Partner for Santavani Musical Concert",
      description: [
        "Celebrate the rich heritage of Santavani music.",
        "Enjoy live performances by renowned artists.",
        "Discover the cultural significance of Santavani in our traditions."
      ],
      images: [music1, music2, music3],
    }
  ];

  const nextImage = (index) => {
    setCurrentImages((prev) =>
      prev.map((imgIdx, i) => (i === index ? (imgIdx + 1) % activities[index].images.length : imgIdx))
    );
  };

  const prevImage = (index) => {
    setCurrentImages((prev) =>
      prev.map((imgIdx, i) => (i === index ? (imgIdx - 1 + activities[index].images.length) % activities[index].images.length : imgIdx))
    );
  };

  return (
    <div className="activity-container">
      {activities.map((activity, index) => (
        <div key={index} className="activity">
          <div className="activity-images">
            <img
              src={activity.images[currentImages[index]]}
              alt={`${activity.title} ${currentImages[index] + 1}`}
              className="activity-image"
            />
            <div className="arrow-left" onClick={() => prevImage(index)}>&#10094;</div>
            <div className="arrow-right" onClick={() => nextImage(index)}>&#10095;</div>
          </div>
          <div className="activity-details">
            <h2 className="activity-title">{activity.title}</h2>
            <ul className="activity-description">
              {activity.description.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityDetail;
